import axiosOriginal from "axios";
import TokenManager from "./tokenManager";

export const tokenManager = TokenManager.getInstance();

const axios = axiosOriginal.create({
    baseURL: process.env.REACT_APP_WEB_API,
});
const api = axiosOriginal.create({
    baseURL: process.env.REACT_APP_WEB_API,
});

const axiosUnauth = axiosOriginal.create({
    baseURL: process.env.REACT_APP_WEB_API,
});


// Add request interceptor to automatically add valid token
api.interceptors.request.use(async (config) => {
    try {
        const token = await tokenManager.getValidToken();
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    } catch (error) {
        // Handle token error (e.g., redirect to login)
        throw error;
    }
});

api.interceptors.response.use(
    async (response) => {
        //This is to fix AD-251(Prevent multiple multiple Inactive toast msg.)
        if (response?.data?.msg === "You are not active user.") {
            await tokenManager.clearTokens();
            sessionStorage.setItem("inactiveUser", "You are not active user.")
            return Promise.reject("You are not active user.");
        }
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        // If we get a 401 and haven't tried to refresh yet
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const tokenManager = TokenManager.getInstance();
                // Force a token refresh
                await tokenManager.refreshToken();

                // Update the failed request with new token and retry
                const newToken = await tokenManager.getValidToken();
                originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
                return api(originalRequest);
            } catch (refreshError) {
                // tokenManager.refreshToken() already calls expireSession() internally
                // when the failure is a genuine auth failure (401/403/invalid_grant) —
                // it deliberately does NOT do so for transient network errors, so we
                // must not override that decision here.
                throw refreshError;
            }
        }

        throw error;
    }
);

// Export api as default and as 'axios' for backward compatibility
export { api as axiosAuth, axiosUnauth, axios };
export default api;
